import { useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { CreditCard, ShoppingCart, RefreshCw } from 'lucide-react';
import WcOrdersPage from './WcOrdersPage';
import HelloAssoAdminPage from './HelloAssoAdminPage';

const TABS = [
  { key: 'orders', label: 'Tous les paiements', icon: ShoppingCart },
  { key: 'helloasso', label: 'HelloAsso', icon: RefreshCw },
];

const PaiementsPage = () => {
  const [tab, setTab] = useState('orders');

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6" style={{ fontFamily: "'Nunito', 'Roboto', sans-serif" }} data-testid="paiements-page">
        {/* Header + Tabs */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#eaf6fc] flex items-center justify-center">
              <CreditCard size={18} className="text-[#35AFE4]" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#1e3a5f]" style={{ fontFamily: "'Barlow', sans-serif" }}>Cotisations & Paiements</h1>
              <p className="text-xs text-gray-400">Gestion centralisée des paiements et adhésions</p>
            </div>
          </div>

          <div className="flex bg-white rounded-lg border border-gray-200 p-0.5 w-fit" data-testid="paiements-tabs">
            {TABS.map(t => {
              const Icon = t.icon;
              return (
                <button key={t.key} onClick={() => setTab(t.key)}
                  className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-xs font-semibold transition-all ${tab === t.key ? 'bg-[#1e3a5f] text-white shadow-sm' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}`}
                  data-testid={`tab-${t.key}`}>
                  <Icon size={13} />{t.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Content */}
        {tab === 'orders' && <WcOrdersPage />}
        {tab === 'helloasso' && <HelloAssoAdminPage />}
      </div>
    </AdminLayout>
  );
};

export default PaiementsPage;
